import {
  ADD_EMAIL_TO_NEW_MEMBER,
  GET_CUSTOMERS_DETAILS,
  GET_CUSTOMERS_ORDERS,
  GET_CUSTOMERS_ORDER_DETAILS,
  GET_CUSTOMERS_PERSONAL,
  GET_CUSTOMERS_TEAM,
  GET_USER_SETTINGS_FAIL,
  GET_USER_SETTINGS_REQUEST,
  GET_USER_SETTINGS_SUCCESS,
  MTB_ADD_DIRECT_BREADCRUMBS,
  MTB_ADD_NEW_MEMBER_MODAL,
  MTB_CLEAR_DIRECT_BREADCRUMBS,
  MTB_GET_BOTTOM_TEAM_MEMBER,
  MTB_GET_DIRECT_LEG_USERS,
  MTB_GET_DIRECT_MEMBERS,
  MTB_GET_ROOT_TEAM_MEMBER,
  MTB_INIT,
  MTB_LEVELS,
  MTB_POP_DIRECT_BREADCRUMB,
  MTB_UNILEVEL,
  MTB_VOLUME,
  REMOVE_MY_TEAM_STATE,
  UPDATE_USER_SETTINGS_FAIL,
  UPDATE_USER_SETTINGS_REQUEST,
  UPDATE_USER_SETTINGS_SUCCESS
} from './myTeamBackOffice.constants';

const INITIAL_STATE = {
  rootTeamMemberTrading: null,
  rootTeamMemberInfoTrading: null,
  rootTeamMember: null,
  rootTeamMemberInfo: null,
  userAsTeamMember: null,
  userAsTeamMemberInfo: null,
  leftDirectUsers: [],
  rightDirectUsers: [],
  directBreadcrumbs: [],
  addNewMemberModal: {
    isOpen: false,
    parentId: null,
    position: null
  },
  isLoadingDirect: false,
  isLoading: false,
  loadingLeftUsers: false,
  loadingRightUsers: false,
  volumeInfo: null,
  customers: null
};

export const myTeamBackoffice = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MTB_INIT.REQUEST:
    case MTB_VOLUME.REQUEST:
    case MTB_LEVELS.REQUEST:
    case MTB_UNILEVEL.REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case MTB_INIT.SUCCESS:
    case MTB_VOLUME.SUCCESS:
    case MTB_LEVELS.SUCCESS:
    case MTB_UNILEVEL.SUCCESS:
      return {
        ...state,
        isLoading: false,
        ...action.payload
      };
    case MTB_INIT.FAIL:
    case MTB_VOLUME.FAIL:
    case MTB_LEVELS.FAIL:
    case MTB_UNILEVEL.FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };

    case MTB_GET_ROOT_TEAM_MEMBER.REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case MTB_GET_ROOT_TEAM_MEMBER.SUCCESS:
      return {
        ...state,
        isLoading: false,
        ...action.payload
      };
    case MTB_GET_ROOT_TEAM_MEMBER.FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    //
    case MTB_GET_DIRECT_MEMBERS.REQUEST:
      return {
        ...state,
        isLoadingDirect: true
      };
    case MTB_GET_DIRECT_MEMBERS.SUCCESS:
      return {
        ...state,
        isLoadingDirect: false,
        ...action.payload
      };
    case MTB_GET_DIRECT_MEMBERS.FAIL:
      return {
        ...state,
        isLoadingDirect: false,
        error: action.payload
      };

    case MTB_GET_DIRECT_LEG_USERS.REQUEST:
      return {
        ...state,
        loadingLeftUsers: action.payload === 0 ? true : false,
        loadingRightUsers: action.payload === 1 ? true : false
      };
    case MTB_GET_DIRECT_LEG_USERS.SUCCESS:
      return {
        ...state,
        loadingLeftUsers: false,
        loadingRightUsers: false,
        leftDirectUsers:
          action.payload.leg === 0
            ? [...state.leftDirectUsers, ...action.payload.directUsers]
            : state.leftDirectUsers,
        rightDirectUsers:
          action.payload.leg === 1
            ? [...state.rightDirectUsers, ...action.payload.directUsers]
            : state.rightDirectUsers
      };
    case MTB_GET_DIRECT_LEG_USERS.FAIL:
      return {
        ...state,
        loadingLeftUsers: false,
        error: action.payload
      };
    //
    case MTB_GET_BOTTOM_TEAM_MEMBER.REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case MTB_GET_BOTTOM_TEAM_MEMBER.SUCCESS:
      return {
        ...state,
        isLoading: false,
        ...action.payload
      };
    case MTB_GET_BOTTOM_TEAM_MEMBER.FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      }; //
    case MTB_ADD_NEW_MEMBER_MODAL.OPEN:
      return {
        ...state,
        addNewMemberModal: {
          isOpen: true,
          parentId: action.payload.parentId,
          position: action.payload.position
        }
      };

    case MTB_ADD_NEW_MEMBER_MODAL.CLOSE:
      return {
        ...state,
        addNewMemberModal: {
          isOpen: false,
          parentId: null,
          position: null
        }
      };
    //
    case MTB_ADD_DIRECT_BREADCRUMBS:
      return {
        ...state,
        directBreadcrumbs: [...state.directBreadcrumbs, action.payload]
      };

    case MTB_CLEAR_DIRECT_BREADCRUMBS:
      return {
        ...state,
        directBreadcrumbs: []
      };

    case MTB_POP_DIRECT_BREADCRUMB:
      // eslint-disable-next-line no-case-declarations
      const newBreadCrumbs = state.directBreadcrumbs;
      newBreadCrumbs.pop();
      return {
        ...state,
        directBreadcrumbs: [...newBreadCrumbs]
      };
    //

    case GET_CUSTOMERS_TEAM.SUCCESS:
      return {
        ...state,
        isLoading: false,
        customers: {
          ...state.customers,
          teamUsers: action.payload
        }
      };

    case GET_CUSTOMERS_PERSONAL.SUCCESS:
      return {
        ...state,
        isLoading: false,
        customers: {
          ...state.customers,
          personalUsers: action.payload
        }
      };

    case GET_CUSTOMERS_ORDERS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        customers: {
          ...state.customers,
          orders: action.payload
        }
      };

    case GET_CUSTOMERS_DETAILS.REQUEST:
      return {
        ...state,
        loading: true
      };

    case GET_CUSTOMERS_DETAILS.SUCCESS:
      return {
        ...state,
        loading: false,
        customers: {
          ...state.customers,
          customerDetails: {
            user: action.payload.user,
            orders: action.payload.orders
          }
        }
      };

    case GET_CUSTOMERS_DETAILS.FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };

    case GET_CUSTOMERS_ORDER_DETAILS.REQUEST:
      return {
        ...state,
        loading: true
      };

    case GET_CUSTOMERS_ORDER_DETAILS.SUCCESS:
      return {
        ...state,
        loading: false,
        customers: {
          ...state.customers,
          customerDetails: {
            ...state.customers.customerDetails,
            order: action.payload
          }
        }
      };

    case ADD_EMAIL_TO_NEW_MEMBER.FAIL:
      return {
        error: action.payload
      };

    case GET_USER_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true
      };

    case GET_USER_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        ...action.payload
      };

    case GET_USER_SETTINGS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    //USER SETTINGS

    case UPDATE_USER_SETTINGS_REQUEST:
      return { ...state, loading: true };

    case UPDATE_USER_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        ...action.payload
      };

    case UPDATE_USER_SETTINGS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case REMOVE_MY_TEAM_STATE:
      return INITIAL_STATE;

    default:
      return state;
  }
};
